export const getItemsId = (items) => items.map((item) => item.variant_id);
export const filterByItemId = (items) => (item) => !items.includes(Number(item.variantId));
